import { logger } from '@/helpers/logger';
import { useQuery } from 'react-query';
import * as ajax from '../../helpers/ajax';
import type { CmsNode } from '../../models/cms';
import { PRESS_ARTICLE_DATA_PATH } from './consts';
import { PressArticle } from './types';

const getPressArticles = async (
  pressType?: string
): Promise<Readonly<PressArticle>[]> => {
  try {
    const data =
      (await ajax.getJsonCached<readonly CmsNode[]>(PRESS_ARTICLE_DATA_PATH)) ??
      [];

    const results = data.map(
      ({
        id,
        image,
        path,
        mainTag,
        mediaType,
        tags,
        publicationDate,
        teaserText,
        title,
        pressType,
      }) => {
        return {
          id,
          image,
          path,
          mainTag,
          mediaType,
          tags,
          publicationDate,
          teaserText,
          title,
          pressType,
        };
      }
    );

    if (pressType) {
      return results.filter((item) => item.pressType === pressType);
    }

    return results;
  } catch (error) {
    logger.error('getPressArticles', error);
    return [];
  }
};

export default function usePressArticles(pressType?: string) {
  return useQuery('press-articles', () => getPressArticles(pressType));
}
